import { render } from "./PhysiciansReport.vue?vue&type=template&id=bfd245c6"
import script from "./PhysiciansReport.vue?vue&type=script&lang=js"
export * from "./PhysiciansReport.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/reports/PhysiciansReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfd245c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfd245c6', __exports__)) {
    console.log('reload')
    api.reload('bfd245c6', __exports__)
  }
  
  module.hot.accept("./PhysiciansReport.vue?vue&type=template&id=bfd245c6", () => {
    console.log('re-render')
    api.rerender('bfd245c6', render)
  })

}


export default __exports__